import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';

export const PreviewGalleryPostCardTextBlock = memo(
  ({ title, categoryTitle, smallTile = false, themeIndependent = false, style }) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.textContainer, style]}>
        <View style={styles.titleContainer}>
          <Text
            style={[
              styles.titleText,
              smallTile && styles.regularTitleText,
              themeIndependent && styles.panelTitleText,
            ]}
          >
            {title}
          </Text>
          <Text
            style={[styles.subtitleText, themeIndependent && styles.panelSubtitleText]}
          >
            {categoryTitle}
          </Text>
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleContainer: {
    flex: 1,
  },
  titleText: {
    fontSize: 16,
    color: colors.title,
    fontWeight: 'bold',
    textAlign: 'left',
  },
  regularTitleText: {
    fontSize: 14,
    fontWeight: '500',
  },
  panelTitleText: {
    fontWeight: 'bold',
    color: colors.gray23,
  },
  subtitleText: {
    fontSize: 14,
    color: colors.subtitle,
    textAlign: 'left',
  },
  panelSubtitleText: {
    color: colors.gray21,
  },
}));
